<template>
  <!--Left Box Menu-->
  <div
    class="left-site-menu dashboar-leftbar"
    style="background-color: var(--box-two)"
  >
    <div class="left-box">
      <div class="custom-scroll-animated">
        <div class="dashboard-active cross-icon">
          <i class="fas fa-times"></i>
        </div>
        <header class="header" style="background: none">
          <nav class="menu">
            <ul class="main-list-menu">
              <li>
                <ul class="menu-promot menu-promot-middle">
                  <li>
                    <router-link
                      to="/"
                      :class="{ active: $route.name === 'home' }"
                    >
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/15.png"
                          alt="pro-img"
                        />
                      </div>
                      <span> {{ $t("Home") }} </span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/games"
                      :class="{ active: $route.name === 'games' }"
                    >
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/gamm.png"
                          alt="pro-img"
                        />
                      </div>
                      <span>{{ $t("All Game") }}</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/popular-games"
                      :class="{ active: $route.name === 'popular-games' }"
                    >
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/g9.png"
                          alt="pro-img"
                        />
                      </div>
                      <span> {{ $t("Populars Game") }} </span>
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      to="/new-games"
                      :class="{ active: $route.name === 'new-games' }"
                    >
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/g8.png"
                          alt="pro-img"
                        />
                      </div>
                      <span> {{ $t("New Games") }} </span>
                    </router-link>
                  </li>
                  <li v-if="isLoggedIn">
                    <router-link
                      to="/favorites"
                      :class="{ active: $route.name === 'favorites' }"
                    >
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/g7.png"
                          alt="pro-img"
                        />
                      </div>
                      <span> {{ $t("My favorites") }} </span>
                    </router-link>
                  </li>
                  <li v-if="isLoggedIn">
                    <router-link
                      to="/recent-view"
                      :class="{ active: $route.name === 'recent-view' }"
                    >
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/g6.png"
                          alt="pro-img"
                        />
                      </div>
                      <span> {{ $t("Recent Viewed") }} </span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li>
                <ul class="menu-promot mt-4">
                  <li class="pro">{{ $t("Personal") }}</li>
                  <li v-if="isLoggedIn">
                    <router-link to="/profile">
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/profile.svg"
                          alt="pro-img"
                          width="20px"
                          height="20px"
                        />
                      </div>
                      <span> {{ $t("Profile") }} </span>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/leaderboard">
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/leaderboard.svg"
                          alt="pro-img"
                          width="20px"
                          height="20px"
                        />
                      </div>
                      <span> {{ $t("Leaderboard") }} </span>
                    </router-link>
                  </li>
                  <li v-if="isLoggedIn">
                    <router-link to="/unsubscribe">
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/unsubscribe.svg"
                          alt="pro-img"
                          width="20px"
                          height="20px"
                        />
                      </div>
                      <span> {{ $t("Unsubscribe") }} </span>
                    </router-link>
                  </li>
                  <li
                    v-if="!isLoggedIn || (userInfo && !userInfo.is_subscribed)"
                  >
                    <a @click.prevent="openSubscription" href="#">
                      <div class="icon">
                        <img
                          src="@/assets/img/header/left-menu/subscribe.svg"
                          alt="pro-img"
                          width="20px"
                          height="20px"
                        />
                      </div>
                      <span> {{ $t("Subscribe") }} </span>
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <ul class="page-link-wrapper">
                  <!-- <li>
                    <a href="javascript:;"> Fair </a>
                  </li>
                  <li>
                    <a href="javascript:;"> FAQ </a>
                  </li> -->
                  <li class="d-flex align-items-center gap-3">
                    <span>{{ $t("Language") }}</span>
                    <div class="nice-select" tabindex="0">
                      <ul class="list">
                        <li
                          v-for="lang in languages"
                          :key="lang.code"
                          :class="{
                            option: true,
                            focus: currentLocale === lang.code,
                            selected: currentLocale === lang.code,
                          }"
                          @click="changeLanguage(lang.code)"
                        >
                          <img
                            v-lazy="getFlag(lang.code)"
                            alt="flag-img"
                            style="border-radius: 50%; object-fit: cover"
                          />
                          {{ lang.name }}
                        </li>
                      </ul>
                      <a href="javascript:;" class="icon">
                        <img
                          v-lazy="getFlag(currentLocale)"
                          alt="flag-img"
                          style="border-radius: 50%; object-fit: cover"
                        />
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="hamburger"><span></span></div>
            <div class="hamb"><span></span></div>
            <div class="dimmer"></div>
          </nav>
        </header>
      </div>
    </div>
  </div>
  <!--Left Box Menu-->
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useLanguageStore } from "@/store/language";
import { useAuthStore } from "@/store/auth";
import helpers from "@/helpers";

export default {
  name: "SidebarComponent",
  inject: ["isRtlLayout"],
  data() {
    return {
      languages: [],
    };
  },
  computed: {
    ...mapState(useAuthStore, ["isLoggedIn", "userInfo"]),
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    $route() {
      this.removeSidebarClass();
    },
  },
  methods: {
    ...mapActions(useLanguageStore, ["setLocale"]),
    ...mapActions(useAuthStore, ["logout", "unsubscribe", "openPaymentPage"]),
    changeLanguage(code) {
      this.$i18n.locale = code;
      localStorage.setItem("local", code);

      const html = document.documentElement;
      html.lang = code;
      html.dir = this.isRtlLayout ? "rtl" : "ltr";

      window.location.reload();
    },
    openSubscription() {
      localStorage.setItem("redirectUrl", this.$route.fullPath);

      let config = helpers.getConfig();
      if (config.subscription_type == "card") {
        if (!this.isLoggedIn) {
          this.openLogin();
        } else {
          this.openPaymentPage();
        }
      } else {
        window.location.href = config.landing_page_url;
      }
    },
    removeSidebarClass() {
      const sidebar = document.querySelector(
        ".left-site-menu.dashboar-leftbar",
      );
      if (sidebar && sidebar.classList.contains("active")) {
        sidebar.classList.remove("active");
      }
    },
    getFlag(code) {
      const flagMap = {
        ar: "https://flagcdn.com/w40/sa.webp",
        en: "https://flagcdn.com/w40/gb.webp",
        am: "https://flagcdn.com/w40/et.webp",
        om: "https://flagcdn.com/w40/et.webp",
        ti: "https://flagcdn.com/w40/er.webp",
        so: "https://flagcdn.com/w40/so.webp",
        fa: "https://flagcdn.com/w40/ir.webp",
        fr: "https://flagcdn.com/w40/fr.webp",
      };

      return flagMap[code] || "";
    },
  },
  mounted() {
    const savedLang = localStorage.getItem("local");
    if (savedLang) {
      this.$i18n.locale = savedLang;

      const html = document.documentElement;
      html.lang = savedLang;
      html.dir = this.isRtlLayout ? "rtl" : "ltr";
    }

    let config = helpers.getConfig();
    this.languages = config ? config.languages_list : [];
  },
};
</script>

<style>
.nice-select .list {
  max-height: 200px !important;
  overflow-y: auto !important;
}
</style>
